import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTripleChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12.8 2.68188H10.24L13.44 8.50007L10.24 14.3182H12.8L16 8.50007L12.8 2.68188ZM7.68 2.68188H5.12L8.32 8.50007L5.12 14.3182H7.68L10.88 8.50007L7.68 2.68188ZM2.56 2.68188H0L3.2 8.50007L0 14.3182H2.56L5.76 8.50007L2.56 2.68188Z" })
});
export default SvgIconTripleChevron;
